export default __webpack_public_path__ + "static/media/bg-engenharia-produto.4d9c5685.webp";